import {Component, Input} from '@angular/core';
import {AppState} from '../../../store/store';
import {Store} from '@ngrx/store';
import {reportOpenPeriodDialog} from '../../../store/report/report.actions';

@Component({
  selector: 'app-report-period-setting-button',
  templateUrl: './report-period-setting-button.component.html',
  styleUrls: ['./report-period-setting-button.component.scss']
})
export class ReportPeriodSettingButtonComponent {
  @Input() public disableComparison: boolean = false;

  constructor(
    private readonly _store: Store<AppState>
  ) {}

  public onClick(): void {
    this._store.dispatch(reportOpenPeriodDialog({
      disableComparison: this.disableComparison
    }));
  }
}
